module.exports = __webpack_public_path__ + "img/loading.c65cba2e.png";